<template>
  <div>
    <div class="wraper">
      <div class="container-fluid mycontainer-fluid">
        <slot name="header"></slot>
        <div class="row myrow">
          <div class="col-xs-12 mycol header-title">
            <div class="col-xs-12 mycol">
              <div class="h-t-name pull-left">Проекты</div>
              <div class="pull-right">
                <button
                  v-if="createProjectButton"
                  class="btn btn-success"
                  style="margin-right: 12px; padding: 4px"
                  v-on:click="showCreateProjectPanel"
                >
                  Создать проект
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid mycontainer-fluid content content_table">
        <div class="wrapper-header">
          <form v-on:submit.prevent="fetchProjects">
            <div class="row myrow project-filter filter-wrapper-stl">
              <div
                class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
              >
                <input
                  id="filter_number"
                  type="text"
                  class="filter-input-stl"
                  placeholder="Номер проекта"
                  v-model="filter.number"
                />
              </div>
              <div
                class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
              >
                <input
                  id="filter_org_name"
                  type="text"
                  class="filter-input-stl"
                  placeholder="Организация"
                  v-model="filter.org_name"
                />
              </div>
              <div
                class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
              >
                <Multiselect
                  label="NAME"
                  class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                  :limit="1"
                  :limitText="filterItemText"
                  track-by="ID"
                  v-model="filter.program"
                  :options="finSupport"
                  :multiple="true"
                  placeholder="Программа"
                />
              </div>
              <div
                class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
              >
                <input
                  id="filter_name"
                  type="text"
                  class="filter-input-stl"
                  placeholder="Название проекта"
                  v-model="filter.name"
                />
              </div>
              <div
                class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
              >
                <Multiselect
                  label="NAME"
                  class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                  :limit="1"
                  :limitText="filterItemText"
                  track-by="ID"
                  v-model="filter.region"
                  :options="regionSupport"
                  :multiple="true"
                  placeholder="Регион"
                />
              </div>
              <div
                class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
              >
                <Multiselect
                  label="NAME"
                  class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style ms-select-full filter-select-stl"
                  :limit="1"
                  :limitText="filterItemText"
                  track-by="ID"
                  v-model="filter.status"
                  :options="statusSupport"
                  :multiple="true"
                  placeholder="Статус проекта"
                />
              </div>

              <div
                class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                v-if="currentUser.TYPE_USER === 'manager'"
              >
                <Multiselect
                  label="FULL_NAME"
                  class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                  :limit="1"
                  :limitText="filterItemText"
                  track-by="ID"
                  v-model="filter.manager"
                  :options="managerList"
                  :multiple="true"
                  placeholder="Менеджер проекта"
                />
              </div>

              <div
                class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                v-if="currentUser.TYPE_USER === 'manager'"
              >
                <Multiselect
                  label="FULL_NAME"
                  class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                  :limit="1"
                  :limitText="filterItemText"
                  track-by="ID"
                  v-model="filter.managerOSP"
                  :options="managerOSPList"
                  :multiple="true"
                  placeholder="Менеджер сопровождения"
                />
              </div>

              <div
                class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                v-if="currentUser.TYPE_USER === 'manager'"
              >
                <Multiselect
                  label="FULL_NAME"
                  class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                  :limit="1"
                  :limitText="filterItemText"
                  track-by="ID"
                  v-model="filter.managerEA"
                  :options="managerEAList"
                  :multiple="true"
                  placeholder="Менеджер ЭО/ВЭ"
                />
              </div>
              <div class="stl-df-ac" style="width: 394px;">
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <button
                    type="button"
                    class="project-filter__butt-btn butt-new-style butt-new-style-reset stl-w-full"
                    v-on:click="clearFilter"
                  >
                    СБРОС
                  </button>
                </div>

                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <button
                    class="project-filter__butt-btn butt-new-style stl-w-full"
                    type="submit"
                  >
                    Применить
                  </button>
                </div>
              </div>
            </div>

            <!--<div class="row myrow clearfix project-filter__butt df-ac">

            </div>-->
          </form>
        </div>
        <div class="table-responsive container-stl" v-if="!isLoading">
          <table class="table table-hover table-striped table-new-style">
            <thead>
            <tr>
              <th class="text-nowrap">
                №
                <a
                  v-on:click="setOrder('UF_NUMBER')"
                  class="sort"
                  v-bind:class="{
                      desc: sortColumn === 'UF_NUMBER' && sortOrder === 'DESC'
                    }"
                ></a>
              </th>
              <th class="text-nowrap">
                Заявитель
                <a
                  href="#"
                  v-on:click="setOrder('UF_COMPANY_ID')"
                  class="sort"
                  v-bind:class="{
                      desc:
                        sortColumn === 'UF_COMPANY_ID' && sortOrder === 'DESC'
                    }"
                ></a>
              </th>
              <th class="text-nowrap">
                Программа
                <a
                  v-on:click="setOrder('UF_SUPPORT_PROG_ID')"
                  class="sort"
                  v-bind:class="{
                      desc:
                        sortColumn === 'UF_SUPPORT_PROG_ID' &&
                        sortOrder === 'DESC'
                    }"
                ></a>
              </th>
              <th class="text-nowrap">
                Название проекта
                <a
                  v-on:click="setOrder('UF_NAME')"
                  class="sort"
                  v-bind:class="{
                      desc: sortColumn === 'UF_NAME' && sortOrder === 'DESC'
                    }"
                ></a>
              </th>
              <th class="text-nowrap">
                Регион
                <a
                  v-on:click="setOrder('UF_REGION_ID')"
                  class="sort"
                  v-bind:class="{
                      desc:
                        sortColumn === 'UF_REGION_ID' && sortOrder === 'DESC'
                    }"
                ></a>
              </th>
              <th class="text-nowrap">
                Статус
                <a
                  v-on:click="setOrder('UF_STATUS_ID')"
                  class="sort"
                  v-bind:class="{
                      desc:
                        sortColumn === 'UF_STATUS_ID' && sortOrder === 'DESC'
                    }"
                ></a>
              </th>
              <th class="text-nowrap">
                Менеджер проекта
                <a
                  v-on:click="setOrder('UF_MANAGER_ID')"
                  class="sort"
                  v-bind:class="{
                      desc:
                        sortColumn === 'UF_MANAGER_ID' && sortOrder === 'DESC'
                    }"
                ></a>
              </th>
              <th class="text-nowrap">
                Сумма займа, тыс. руб
                <a
                  v-on:click="setOrder('UF_SUM_REQUEST')"
                  class="sort"
                  v-bind:class="{
                      desc:
                        sortColumn === 'UF_SUM_REQUEST' && sortOrder === 'DESC'
                    }"
                ></a>
              </th>
              <th class="text-nowrap">
                Загружено<br />документов
                <!-- Уведомления <a
                href="#"
                v-on:click="setOrder('COUNT_NEW_MESSAGE')"
                class="sort"
                v-bind:class="{
                  desc:
                    sortColumn === 'COUNT_NEW_MESSAGE' &&
                    sortOrder === 'DESC'
                }"
              ></a>-->
              </th>
              <th class="text-nowrap">
                Дата последнего изменения
                <a
                  v-on:click="setOrder('HISTORY_STATUS_DATA_START')"
                  class="sort"
                  v-bind:class="{
                      desc:
                        sortColumn === 'HISTORY_STATUS_DATA_START' &&
                        sortOrder === 'DESC'
                    }"
                ></a>
              </th>
              <td></td>
            </tr>
            </thead>
            <tbody v-if="projects.counts">
            <tr
              class="new"
              unselectable="on"
              v-for="project in projects.items"
              v-bind:key="project.ID"
              style="cursor: default"
            >
              <td>{{ project.UF_NUMBER }}</td>
              <td>{{ project.COMPANY.NAME }}</td>
              <td>{{ project.PROGRAM.NAME }}</td>
              <td>
                <router-link
                  :to="{
                      name: 'ProjectEdit',
                      params: { id: project.ID }
                    }"
                  style="color: #002333; text-decoration-line: underline;"
                >{{ project.UF_NAME }}
                </router-link>
              </td>
              <td>{{ project.REGION.NAME }}</td>
              <td>{{ project.STATUS.NAME }}</td>
              <td>{{ project.MANAGER.NAME }}</td>
              <td>{{ project.UF_SUM_REQUEST | toCurrency }}</td>
              <!--<td>
               <router-link
                 :to="{
                   name: 'ProjectNotifications',
                   params: { id: project.ID }
                 }"
                 class="table-message"
                 >{{ project.COUNT_NEW_MESSAGE }}
               </router-link>
             </td>-->
              <td style="text-align: center;">
                  <span v-if="project.DOCUMENT_COUNT_NEED_LOAD > 0">
                    {{ project.DOCUMENT_COUNT_FACT_LOAD }}/{{
                      project.DOCUMENT_COUNT_NEED_LOAD
                    }}
                  </span>
              </td>
              <td>{{ project.HISTORY_STATUS_DATA_START }}</td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
              <td colspan="6">Проекты не найдены</td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <td colspan="10">
                <div class="paging">
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col-xs-6 mycol">
                        <Pagination
                          :pages="pages"
                          :currentPage.sync="currentPage"
                        ></Pagination>
                      </div>
                      <div class="col-xs-6 mycol">
                        <div class="pull-right page-total">
                            <span style="padding-right: 15px"
                            >Всего: {{ projects.counts }}</span
                            >
                          <span>Выводить по</span>
                          <span>
                              <select
                                class="page-select"
                                v-model="itemsPerPage"
                              >
                                <option value="20">20</option>
                                <option value="40">40</option>
                                <option value="100">100</option>
                                <option value="500">500</option>
                              </select>
                            </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            </tfoot>
          </table>
        </div>

        <div v-else>
          <h3>Загрузка...</h3>
        </div>
        <div
          class="modal fade in"
          v-bind:class="{ show: showCreateNewProject }"
          tabindex="-1"
          role="dialog"
        >
          <form v-on:submit.prevent="onCreateProject">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <button
                    type="button"
                    class="close"
                    v-on:click="showCreateNewProject = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 class="modal-title">Создать проект</h4>
                </div>
                <div class="modal-body">
                  <div
                    class="alert alert-danger"
                    v-show="addError !== ''"
                    role="alert"
                  >
                    {{ addError }}
                  </div>

                  <div class="form-group">
                    <label>Название</label>
                    <div class="info-holder-container">
                      <div class="info-holder-icon info-holder-icon_inp"></div>
                      <div class="info-holder-content info-holder-content_inp">
                        <div class="info-holder-content__text">
                          Укажите краткое название проекта. Вы сможете его
                          скорректировать или дополнить позднее
                        </div>
                      </div>
                      <input
                        v-model="newProject.name"
                        class="form-control"
                        placeholder="Название проекта"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Программа</label>
                    <div class="info-holder-container">
                      <div
                        class="info-holder-icon info-holder-icon_inp"
                        style="right: 20px"
                      ></div>
                      <div class="info-holder-content info-holder-content_inp">
                        <div class="info-holder-content__text">
                          Изменить программу финансирования по проекту возможно
                          только при подаче новой заявки. Пожалуйста, обратитесь
                          за консультацией, если сомневаетесь в выборе
                        </div>
                      </div>
                      <select
                        class="form-control"
                        @change="directionBySupport()"
                        v-model="newProject.support_prog_id"
                      >
                        <option
                          v-for="item in userProjectProgrammes"
                          v-bind:key="item.ID"
                          v-bind:value="item.ID"
                          v-text="item.NAME"
                        />
                      </select>
                    </div>
                  </div>

                  <div class="form-group" v-if="isViewTypeZaimLoan">
                    <label>Направление займа</label>
                    <div class="info-holder-container">
                      <select
                        class="form-control"
                        v-model="newProject.uf_type_loan_id"
                        :disabled="false"
                      >
                        <option
                          v-for="item in getTypeLoanZaim()"
                          v-bind:key="item.ID"
                          v-bind:value="item.ID"
                          v-text="item.NAME"
                        />
                      </select>
                    </div>
                  </div>

                  <div
                    class="form-group"
                    v-if="
                      isViewTypeZaimLoan &&
                        newProject.uf_type_loan_id == idTypeScalingZaimLoan
                    "
                  >
                    <label
                    >Проект, в рамках которого запущено масштабируемое
                      производство</label
                    >
                    <div class="info-holder-container">
                      <select
                        class="form-control"
                        v-model="newProject.uf_scalable_product_project_id"
                      >
                        <option
                          v-for="item in projects.PROJECT_COMPLECT_LIST"
                          v-bind:key="item.ID"
                          v-bind:value="item.ID"
                          v-text="item.UF_LABEL"
                        />
                      </select>
                    </div>
                  </div>

                  <div class="form-group" v-if="isViewDirectionFinancing">
                    <label>Направление финансирования</label>
                    <div class="info-holder-container">
                      <select
                        class="form-control"
                        v-model="newProject.uf_direction_financing_id"
                        :disabled="isBlockDirectionFinancing"
                      >
                        <option
                          v-for="item in directionBySupport()"
                          v-bind:key="item.ID"
                          v-bind:value="item.ID"
                          v-text="item.NAME"
                        />
                      </select>
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Место реализации проекта</label>
                    <div class="info-holder-container">
                      <select
                        class="form-control"
                        v-model="newProject.region_id"
                      >
                        <option
                          v-for="item in directory.regions"
                          v-bind:key="item.ID"
                          v-bind:value="item.ID"
                          v-text="item.NAME"
                        />
                      </select>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-default"
                    data-dismiss="modal"
                    v-on:click="showCreateNewProject = false"
                  >
                    Отмена
                  </button>
                  <button
                    type="submit"
                    v-bind:disabled="isProjectLoading"
                    class="btn btn-primary"
                  >
                    Создать
                  </button>
                </div>
                <div class="modal-info-help text-center">
                  <div class="stl-clr-black stl-bold">
                    Вы сомневаетесь в выборе программы финансирования?
                  </div>
                  <div>
                    <a
                      href="https://frprf.ru/#constructor"
                      target="_blank"
                      class="stl-bold stl-clr-blue"
                    >воспользуйтесь конструктором</a
                    >
                    <br />
                    или <br />
                    обратитесь за консультацией <br />
                    <a href="+74951202416" class="stl-bold stl-clr-black"
                    >+7 495 120-24-16</a
                    >
                  </div>
                  <div>
                    <a
                      href="https://portal.frprf.ru/online/web/"
                      target="_blank"
                      class="stl-bold stl-clr-blue"
                    >онлайн-чат</a
                    >
                  </div>
                </div>
              </div>
              <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
          </form>
        </div>
        <!-- /.modal -->
        <div
          class="modal fade in"
          v-bind:class="{ show: showListAlert }"
          tabindex="-1"
          role="dialog"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  v-on:click="showListAlert = false"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Уважаемый пользователь!</h4>
              </div>
              <div class="modal-body">
                По итогам проведённого Фондом аудита информационной безопасности
                и в целях предотвращения несанкционированного доступа к данным
                заявителей, принято решение об ограничении доступа для
                пользователей, имеющих роль "{{ listAlertRole }}", к реестру
                проектов с 28 августа 2020 года. Обращаем Ваше внимание на то,
                что данные изменения не влияют на возможность пользования
                сервисами ГИСП под Вашей учетной записью.
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-default"
                  @click="showListAlert = false"
                >
                  Ок
                </button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
        </div>
      </div>
    </div>
    <!-- wraper -->
    <slot name="footer"></slot>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { mapGetters } from "vuex";
import Vue from "vue";
import {
  FETCH_PROJECTS,
  FETCH_PROJECT_TYPES,
  ADD_PROJECT,
  SET_MAIN_MENU,
  FETCH_DIRECTORIES,
  FETCH_DIRECTORY,
  SET_IS_VIEW_ALL_EXPERTISE
} from "@/store/actions.type";
import { ProjectsService } from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
import Multiselect from "vue-multiselect";
import Support from "../Support.vue";

Vue.filter("toCurrency", function(value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat("ru-RU", {
    style: "decimal",
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

export default {
  title: "Реестр проектов",
  components: {
    Support,
    Pagination,
    Multiselect
  },
  data() {
    return {
      extendFilter: false,
      filter: {
        status: [],
        name: "",
        program: [],
        number: "",
        org_name: "",
        archive: "",
        region: [],
        manager: [],
        managerOSP: [],
        managerEA: [],
        UF_DURATION_EXPERTISE_ID: []
      },
      itemsPerPage: 20,
      currentPage: 1,
      sortOrder: "",
      sortColumn: "",
      showCreateNewProject: false,
      showListAlert: false,
      listAlertRole: "",
      sp: {
        statuses: []
      },
      newProject: {
        support_prog_id: "",
        name: "",
        uf_direction_financing_id: "",
        uf_type_loan_id: 0,
        uf_scalable_product_project_id: 0
      },
      addError: "",
      managerList: [],
      managerOSPList: [],
      managerEAList: [],
      isViewDirectionFinancing: false,
      isBlockDirectionFinancing: false,
      isViewTypeZaimLoan: false,
      idTypeScalingZaimLoan: false
    };
  },
  mounted() {
    this.$store.dispatch(SET_MAIN_MENU, []);
    if (
      this.currentUser.ACTIVE_ROLE_CODE === "fo" ||
      this.currentUser.ACTIVE_ROLE_CODE === "region"
    ) {
      this.showListAlert = true;
      if (this.currentUser.ACTIVE_ROLE_CODE === "fo") {
        this.listAlertRole = "Представитель Федерального округа";
      } else {
        this.listAlertRole = "Представитель региона";
      }
    }
    if (this.currentUser.TYPE_USER === "manager") {
      ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
        this.$store.dispatch(
          SET_IS_VIEW_ALL_EXPERTISE,
          data.IS_VIEW_ALL_EXPERTISE
        );
        let navMainMenu = [];
        if (data.START_PAGE === "REESTR_PROJECTS") {
          if (data.IS_REESTR_PROJECTS) {
            navMainMenu.push({
              name: "Реестр проектов",
              route: "Projects"
            });
          }
          if (data.IS_REESTR_EXPERTISE) {
            navMainMenu.push({
              name: "Реестр экспертиз",
              route: "Expertise"
            });
          }
          /*if (data.IS_VIEW_SUBMITTED_PROJECTS) {
            navMainMenu.push({
              name: "Вынесенные проекты",
              route: "SubmittedProjects"
            });
          }*/
          /*if (data.IS_VIEW_MONITOR_LIZING) {
            navMainMenu.push({
              name: "Мониторинг Лизинговых<br/> компаний",
              class: "two_line",
              route: "MonitoringLizingOrgs"
            });
          }
          if (data.IS_VIEW_PLAN_ES) {
            navMainMenu.push({
              name: "Заседания",
              route: "Experts"
            });
          }
          if (
            data.IS_VIEW_VOTE_SOVETE_MODULE &&
            data.IS_VIEW_VOTE_SOVETE_MENU
          ) {
            navMainMenu.push({
              name: "Заседания",
              route: "Conference"
            });
          }
          if (data.IS_VIEW_GROUP_ORG) {
            navMainMenu.push({
              name: "Группы компаний",
              route: "GroupOrgs"
            });
          }*/
          if (data.IS_VIEW_REQUEST_MODULE) {
            navMainMenu.push({
              name: "Запросы",
              route: "Requests"
            });
          }
          if (data.IS_VIEW_ADMIN_MODULE) {
            navMainMenu.push({
              name: "Администрирование",
              route: "Administration"
            });
          }
        } else {
          if (data.IS_REESTR_PROJECTS) {
            navMainMenu.push({
              name: "Реестр проектов",
              route: "Projects"
            });
          }
          if (data.IS_REESTR_EXPERTISE) {
            navMainMenu.push({
              name: "Реестр экспертиз",
              route: "Expertise"
            });
          }
          /*if (data.IS_VIEW_SUBMITTED_PROJECTS) {
            navMainMenu.push({
              name: "Вынесенные проекты",
              route: "SubmittedProjects"
            });
          }*/
          /*if (data.IS_VIEW_MONITOR_LIZING) {
            navMainMenu.push({
              name: "Мониторинг лизинговых компаний",
              route: "MonitoringLizingOrgs"
            });
          }
          if (data.IS_VIEW_PLAN_ES) {
            navMainMenu.push({
              name: "Заседания",
              route: "Experts"
            });
          }
          if (
            data.IS_VIEW_VOTE_SOVETE_MODULE &&
            data.IS_VIEW_VOTE_SOVETE_MENU
          ) {
            navMainMenu.push({
              name: "Заседания",
              route: "Conference"
            });
          }
          if (data.IS_VIEW_GROUP_ORG) {
            navMainMenu.push({
              name: "Группы компаний",
              route: "GroupOrgs"
            });
          }*/
          if (data.IS_VIEW_REQUEST_MODULE) {
            navMainMenu.push({
              name: "Запросы",
              route: "Requests"
            });
          }

        }
        this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
      });
    } else if (
      this.currentUser.TYPE_USER === "declarer" &&
      this.currentUser.ACTIVE_ROLE_CODE === "lizing"
    ) {
      ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
        this.$store.dispatch(
          SET_IS_VIEW_ALL_EXPERTISE,
          data.IS_VIEW_ALL_EXPERTISE
        );
        let navMainMenu = [];
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Мои проекты",
            route: "Projects"
          });
        }
        if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
      });
    } else {
      this.$store.dispatch(SET_MAIN_MENU, [
        {
          name:
            this.currentUser.TYPE_USER === "manager"
              ? "Реестр проектов"
              : "Мои проекты",
          route: "Projects"
        }
      ]);
    }
    this.$store.dispatch(FETCH_DIRECTORIES, [
      "status",
      "regions",
      "sp_duration_expertise",
      "sp_direction_financing",
      "sp_types_loans"
    ]);

    this.$store.dispatch(FETCH_DIRECTORY, ["program_fin_support"]).then(() => {
      if (this.currentUser.TYPE_USER === "manager") {
        ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
          this.$store.dispatch(
            SET_IS_VIEW_ALL_EXPERTISE,
            data.IS_VIEW_ALL_EXPERTISE
          );
          if (data.SUPPORT_PROG_DEFAULT_ID.length) {
            if (data.SUPPORT_PROG_DEFAULT_ID.length) {
              if (this.currentUser.ACTIVE_ROLE_CODE === "region_fond") {
                this.filter.program.push({
                  ID: 0,
                  NAME: "Все совместные с ФРП"
                });
              } else {
                this.filter.program.push({
                  ID: 0,
                  NAME: "Все Федеральные"
                });
              }
            }
            for (
              let i = 0;
              i < this.directory.program_fin_support.length;
              i++
            ) {
              console.log(
                data.SUPPORT_PROG_DEFAULT_ID,
                this.directory.program_fin_support[i].ID
              );
              for (let d = 0; d < data.SUPPORT_PROG_DEFAULT_ID.length; d++) {
                if (
                  data.SUPPORT_PROG_DEFAULT_ID[d] ===
                  this.directory.program_fin_support[i].ID
                ) {
                  this.filter.program.push(
                    this.directory.program_fin_support[i]
                  );
                }
              }
            }
          }
        });
      }
    });

    if (this.currentUser.TYPE_USER === "manager") {
      ProjectsService.getManagerRoleDefaultSetting()
        .then(({ data }) => {
          this.$store.dispatch(
            SET_IS_VIEW_ALL_EXPERTISE,
            data.IS_VIEW_ALL_EXPERTISE
          );
          console.log("data.STATUS_DEFAULT_ID: ", data.STATUS_DEFAULT_ID);
          if (data.STATUS_DEFAULT_ID) {
            console.log("this.directory.status: ", this.directory.status);
            // let f = JSON.stringify(this.DStatus);
            // let ret = JSON.parse(f);
            this.directory.status.forEach(r => {
              for (let i = 0; i < data.STATUS_DEFAULT_ID.length; i++) {
                if (r.ID === data.STATUS_DEFAULT_ID[i]) {
                  this.filter.status.push({
                    ID: r.ID,
                    NAME: r.NAME
                  });
                }
              }
            });
          }
          this.fetchProjects();
        }, this)
        .catch(err => console.log(err));
    } else {
      this.fetchProjects();
    }
    ProjectsService.getListManagerProject().then(({ data }) => {
      this.managerList = data;
    }, this);

    ProjectsService.getListManagerDSPProject().then(({ data }) => {
      this.managerOSPList = data;
    }, this);

    ProjectsService.getListManagerEAProject().then(({ data }) => {
      this.managerEAList = data;
    }, this);

    const el = document.getElementsByClassName("area-shadow")[0];
    el.classList.remove("active");
  },
  computed: {
    ...mapGetters([
      "projects",
      "userProjectProgrammes",
      "isProjectLoading",
      "addProjectError",
      "project",
      "isLoading",
      "DStatus",
      "DProgramFinSupport",
      "DRegions",
      "currentUser",
      "directory"
    ]),
    finSupport() {
      let ret = [];
      let f = JSON.stringify(this.DProgramFinSupport);
      ret = JSON.parse(f);
      if (this.currentUser.ACTIVE_ROLE_CODE === "region_fond") {
        ret.unshift({ ID: 0, NAME: "Все совместные с ФРП" });
      } else if (this.currentUser.TYPE_USER === "manager") {
        ret.unshift({ ID: 0, NAME: "Все Федеральные" });
      }

      ret.unshift({ ID: 1, NAME: "Все" });
      return ret;
    },
    regionSupport() {
      let ret = [];
      let f = JSON.stringify(this.DRegions);
      ret = JSON.parse(f);
      ret.unshift({ ID: 0, NAME: "Все" });
      return ret;
    },
    statusSupport() {
      let ret = [];
      let f = JSON.stringify(this.DStatus);
      ret = JSON.parse(f);
      ret.unshift({ ID: 0, NAME: "Все" });
      return ret;
    },
    createProjectButton() {
      if (this.currentUser.TYPE_USER === "declarer") {
        return true;
      }
      return false;
    },
    listConfig() {
      const q = {
        page: this.currentPage,
        limit: this.itemsPerPage,
        filter: {}
      };
      if (this.sortColumn !== "") {
        let sort = {
          column: "",
          order: ""
        };
        sort.column = this.sortColumn;
        sort.order = this.sortOrder;
        q.sort = sort;
      }
      // if (this.filter.status > 0) {
      //   q.filter.UF_STATUS_ID = this.filter.status;

      // }
      if (this.filter.status.length) {
        q.filter.UF_STATUS_ID = [];
        this.filter.status.forEach(function(it) {
          if (it.ID > 0) {
            q.filter.UF_STATUS_ID.push(it.ID);
          }
        }, this);
      }
      if (this.filter.program.length) {
        q.filter.UF_SUPPORT_PROG_ID = [];
        let rb = false;
        this.filter.program.forEach(function(it) {
          if (it.ID > 1) {
            q.filter.UF_SUPPORT_PROG_ID.push(it.ID);
          } else if (it.ID === 1) {
            q.filter.UF_SUPPORT_PROG_ID = ["all"];
          } else {
            rb = true;
          }
        }, this);
        if (this.currentUser.ACTIVE_ROLE_CODE === "region_fond") {
          if (rb) {
            q.filter.UF_SUPPORT_PROG_ID = ["all_region"];
          }
        } else if (this.currentUser.TYPE_USER === "manager") {
          if (rb) {
            q.filter.UF_SUPPORT_PROG_ID = ["all_federal"];
          }
        }
      }

      if (this.filter.region.length) {
        q.filter.UF_REGION_ID = [];
        this.filter.region.forEach(function(it) {
          if (it.ID > 0) {
            q.filter.UF_REGION_ID.push(it.ID);
          }
        }, this);
      }
      if (this.filter.name !== "") {
        q.filter.UF_NAME = this.filter.name;
      }
      if (this.filter.number !== "") {
        q.filter.UF_NUMBER = this.filter.number;
      }
      if (this.filter.archive !== "") {
        q.filter.UF_IS_ARHIVE = this.filter.archive;
      }
      if (this.filter.org_name !== "") {
        q.filter.COMPANY_NAME = this.filter.org_name;
      }

      if (this.filter.manager.length) {
        q.filter.UF_MANAGER_ID = [];
        this.filter.manager.forEach(function(it) {
          if (it.ID > 0) {
            q.filter.UF_MANAGER_ID.push(it.ID);
          }
        }, this);
      }

      if (this.filter && this.filter.managerOSP && this.filter.managerOSP.length) {
        q.filter.UF_MANAGER_OSP = [];
        this.filter.managerOSP.forEach(function(it) {
          if (it.ID > 0) {
            q.filter.UF_MANAGER_OSP.push(it.ID);
          }
        }, this);
      }

      if (this.filter && this.filter.managerEA && this.filter.managerEA.length) {
        q.filter.UF_MANAGER_EA = [];
        this.filter.managerEA.forEach(function(it) {
          if (it.ID > 0) {
            q.filter.UF_MANAGER_EA.push(it.ID);
          }
        }, this);
      }

      return q;
    },
    pages() {
      if (this.isLoading || this.projects.counts <= this.itemsPerPage) {
        return [];
      }
      return [
        ...Array(Math.ceil(this.projects.counts / this.itemsPerPage)).keys()
      ].map(e => e + 1);
    }
  },
  watch: {
    currentPage(newValue) {
      this.listConfig.page = newValue;
      this.fetchProjects();
    },
    itemsPerPage(newValue) {
      this.listConfig.limit = newValue;
      this.fetchProjects();
    }
  },
  methods: {
    getPTypeId(id) {
      let t = this.directory.program_fin_support.filter(
        c => c.UF_SUPPORT_PROG_ID === id
      );
      if (t.length > 0) {
        return t[0].NAME;
      }
      return "";
    },
    getTypeLoanZaim() {
      let ret = this.directory.sp_types_loans;
      let idType = 0;

      ret.forEach(function(type) {
        if (type.CODE == "loan_issued_scaling_up_production") {
          idType = type.ID;
        }
      });

      //this.newProject.uf_type_loan_id = idType;
      this.idTypeScalingZaimLoan = idType;
      return ret;
    },

    setOrder(column) {
      if (this.sortColumn !== column) {
        this.sortOrder = "ASC";
      } else {
        if (this.sortOrder === "DESC") {
          this.sortOrder = "ASC";
        } else {
          this.sortOrder = "DESC";
        }
      }
      this.sortColumn = column;
      this.fetchProjects();
    },
    clearFilter() {
      this.filter = {
        status: [],
        name: "",
        program: [],
        number: "",
        org_name: "",
        archive: "",
        region: [],
        manager: [],
        managerOSP: [],
        managerEA: []
      };
      this.fetchProjects();
    },
    onCreateProject() {
      // название из одних пробелов не считается заполненным
      this.newProject.name = (this.newProject.name || "").trim();
      if (this.newProject.name === "") {
        this.addError = "Не введено название проекта";
        return false;
      }
      this.addError = "";
      this.$store
        .dispatch(ADD_PROJECT, this.newProject)
        .then(() => {
          this.$router.push({
            name: "ProjectEdit",
            params: { id: this.project.ID }
          });
        })
        .catch(() => {
          this.isProjectLoading = true;
          this.addError = this.addProjectError;
        });
      return false;
    },
    showCreateProjectPanel() {
      this.$store.dispatch(FETCH_PROJECT_TYPES).then(() => {
        this.addError = "";
        this.showCreateNewProject = true;
      });
    },
    fetchProjects() {
      this.$store.dispatch(FETCH_PROJECTS, this.listConfig);
    },
    getLinkProjects() {
      ProjectsService.getLinkReestrProjectExcel(this.listConfig).then(
        ({ data }) => {
          window.open(
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link,
            "_blank"
          );
        }
      );
    },
    filterItemText(count) {
      console.log(count);
      return ``;
    },
    directionBySupport() {
      let arrDirectoryFinancing = [];

      if (this.newProject.support_prog_id > 0) {
        let programId = this.newProject.support_prog_id;
        let program = this.directory.program_fin_support.filter(function(f) {
          return f.ID == programId;
        });

        this.directory.sp_direction_financing.forEach(function(indicator) {
          if (indicator.SUPPORT_PROG_ID_LIST.includes(programId)) {
            if (indicator.IS_NOT_ADD !== 1) {
              arrDirectoryFinancing.push(indicator);
            }
          }
        });

        if (program[0].CODE == "providing_mobilization_needs") {
          if (this.projects.MOBILIZATION_PROGRAMM.isBlockMobilization) {
            this.isBlockDirectionFinancing = true;
          }
          if (this.projects.MOBILIZATION_PROGRAMM.idSetMobilization > 0) {
            this.newProject.uf_direction_financing_id = this.projects.MOBILIZATION_PROGRAMM.idSetMobilization;
          }
        } else {
          this.isBlockDirectionFinancing = false;
        }

        if (
          program[0].CODE != "providing_mobilization_needs" &&
          program[0].CODE != "evolution" &&
          program[0].CODE != "regfond" &&
          program[0].CODE != "working" &&
          program[0].CODE != "working_rfrp"
        ) {
          this.newProject.uf_direction_financing_id = 0;
        }

       /*this.isViewTypeZaimLoan =
          program[0].UF_IS_TYPE_LOAN === 1 &&
          this.projects.PROJECT_COMPLECT_LIST.length > 0
            ? true
            : false;
      */
        if (!this.isViewTypeZaimLoan) {
          this.newProject.uf_type_loan_id = 0;
        }
      } else {
        this.newProject.uf_direction_financing_id = 0;
      }
      this.isViewDirectionFinancing =
        arrDirectoryFinancing.length > 0 ? true : false;

      return arrDirectoryFinancing;
    }
  }
};
</script>
